import { generateKeys, generateLocalization } from '../utils';
export const natureOfRequest = generateLocalization('natureOfRequest', generateKeys({
    startIntroducingIbs: {
        value: 'startIntroducingIbs',
        label: 'Start introducing IB\’s',
        localization: { id: '', defaultMessage: '' },
    },
    upgradeCampaign: {
        value: 'upgradeCampaign',
        label: 'Upgrade campaign',
        localization: { id: '', defaultMessage: '' },
    },
    commissionWithdrawals: {
        value: 'commissionWithdrawals',
        label: 'Commission Withdrawals',
        localization: { id: '', defaultMessage: '' },
    },
    corporateIbRequest: {
        value: 'corporateIbRequest',
        label: 'Corporate IB request',
        localization: { id: '', defaultMessage: '' },
    },
    other: {
        value: 'other',
        label: 'Other',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const promoMaterialTypes = generateKeys({
    banner: {
        label: 'Banner',
        value: 'banner',
    },
    logo: {
        label: 'Logo',
        value: 'logo',
    },
    presentation: {
        label: 'Presentation',
        value: 'presentation',
    },
    video: {
        label: 'Video',
        value: 'video',
    },
    brochure: {
        label: 'Brochure',
        value: 'brochure',
    },
    landing_page: {
        label: 'Landing Page',
        value: 'landing_page',
    },
});
export const promoMaterialDimensions = generateKeys({
    size_160_600: {
        label: '160x600',
        value: 'size_160_600',
        width: 160,
        height: 600,
    },
    size_300_250: {
        label: '300x250',
        value: 'size_300_250',
        width: 300,
        height: 250,
    },
    size_300_600: {
        label: '300x600',
        value: 'size_300_600',
        width: 300,
        height: 600,
    },
    size_320_500: {
        label: '320x500',
        value: 'size_320_500',
        width: 320,
        height: 500,
    },
    size_970_250: {
        label: '970x250',
        value: 'size_970_250',
        width: 970,
        height: 250,
    },
    size_custom: {
        label: 'Custom size',
        value: 'size_custom',
        width: 0,
        height: 0,
    },
});
export const promoMaterialTopics = generateKeys({
    partners_presentations: {
        label: 'Partners Presentations',
        value: 'partners_presentations',
        category: promoMaterialTypes.presentation.key,
    },
    clients_presentations: {
        label: 'Clients Presentations',
        value: 'clients_presentations',
        category: promoMaterialTypes.presentation.key,
    },
    how_to_videos: {
        label: '"How-To" videos',
        value: 'how_to_videos',
        category: promoMaterialTypes.video.key,
    },
    generic_videos: {
        label: 'Generic videos',
        value: 'generic_videos',
        category: promoMaterialTypes.video.key,
    },
    partners_brochures: {
        label: 'Partners Brochures',
        value: 'partners_brochures',
        category: promoMaterialTypes.brochure.key,
    },
    clients_brochures: {
        label: 'Clients Brochures',
        value: 'clients_brochures',
        category: promoMaterialTypes.brochure.key,
    },
});
export const promoMaterialFileTypes = generateKeys({
    jpeg: {
        value: 'jpeg',
        label: 'jpeg',
        acceptedTypes: 'image/jpeg',
        category: 'image',
        types: ['jpg', 'jpeg'],
    },
    pdf: {
        value: 'pdf',
        label: 'pdf',
        acceptedTypes: 'application/pdf',
        category: 'file',
        types: ['pdf'],
    },
    other: {
        value: 'other',
        label: 'file',
        acceptedTypes: '*',
        category: 'file',
        types: ['*'],
    },
    video: {
        value: 'video',
        label: 'video',
        acceptedTypes: 'video/mp4',
        category: 'video',
        types: ['mp4'],
    },
});
export const promoMaterialPreviewDimensions = generateKeys({
    banner: {
        label: '',
        value: '',
    },
    logo: {
        label: '',
        value: '',
    },
    presentation: {
        label: '552x309px',
        value: 'size_552_309',
        width: 552,
        height: 309,
    },
    video: {
        label: '552x309px',
        value: 'size_552_309',
        width: 552,
        height: 309,
    },
    brochure: {
        label: '552x552px',
        value: 'size_552_552',
        width: 552,
        height: 552,
    },
    landing_page: {
        label: '',
        value: '',
    },
});
